export const getServerDeploymentColor = (): string | undefined => {
	if ( typeof window !== 'undefined' ) {
		return undefined;
	}

	return process.env.DEPLOYMENT_COLOR;
};
